import React from "react"
import FlexTable from "../flex-table"

export default function ProgramCoursesListingBlock(props): JSX.Element {
  console.log(`ProgramCoursesListingBlock`, props)
  const courseList = props.courseList ?? []

  return courseList.length === 0 ? (
    <div className="alerts-container bg-lightblue text-black px-4 py-2 text-sm">
      No courses are currently available.
    </div>
  ) : (
    <FlexTable
      mobileColumnLabels={false}
      rows={courseList.map((course, index) => [
        <div key={`title-${index}`} sortValue={course.title}>
          {course.courseData ? (
            <a rel="noreferrer" href={course.courseData?.uri}>
              {course.title}
            </a>
          ) : (
            <span>{course.title}</span>
          )}
        </div>,
        <div key={`id-${index}`} sortValue={course.courseId}>
          {course.courseData ? (
            <a rel="noreferrer" href={course.courseData?.uri}>
              {course.courseId}
            </a>
          ) : (
            <>{course.courseId}</>
          )}
        </div>,
        <div key={`equiv-${index}`}>
          {course?.wpEquivalencies
            ?.filter(eq => eq.equivalentCourse !== null)
            ?.map(eq => (
              <a
                key={`${index}-${eq?.equivalentCourse?.courseId}`}
                href={eq?.equivalentCourse?.uri}
                rel="noreferrer"
              >
                {eq?.equivalentCourse?.title}
              </a>
            ))}
        </div>,
      ])}
      className="wp-block-georgiancollege-program-courses-listing mt-4"
      headings={[
        {
          label: `Course title`,
          width: `w-7/12`,
        },
        {
          label: `Course code`,
          width: `w-2/12`,
        },
        {
          label: `OntarioLearn equivalents`,
          width: `w-3/12`,
        },
      ]}
    />
  )
}

{
  /* <div key={`title-${index}`}>
          test
          { {course.courseData ? (
            <a target="_blank" rel="noreferrer" href={course.courseData.uri}>
              {course.title}
            </a>
          ) : (
            <>{course.title}</>
          )} }
        </div>,
        <div key={`id-${index}`}>{course.courseData}</div>,
        <div key={`equiv-${index}`}>
          test
          { {course?.courseData?.wpEquivalencies?.map(eq => (
            <a
              key={`${index}-${eq.courseId}`}
              target="_blank"
              href={eq.uri}
              rel="noreferrer"
            >
              {eq.title}
            </a>
          ))} }
        </div>, */
}
